import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { useApp } from "../AppContext";
import { NAV, TRUST, PARAMPARA, SOURCES } from "../content";
import { OmMark } from "./Motion";

export default function Footer() {
  const { lang } = useApp();
  const L = (o) => o[lang] ?? o.en;
  return (
    <footer className="bg-earth-900 text-sand-100 relative z-10" data-testid="footer">
      {/* Guru Parampara band */}
      <div className="border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10">
          <h4 className="font-serif-head text-2xl text-ochre-400 mb-6 text-center">{lang === "mr" ? "औदुंबर गुरुपरंपरा" : "Audumbar Guru Parampara"}</h4>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-3">
            {PARAMPARA.map((g, i) => (
              <span key={i} className="flex items-center gap-4">
                <span className="text-sand-100/90 text-center">{L(g)}</span>
                {i < PARAMPARA.length - 1 && <OmMark className="w-4 h-4 text-saffron-500" />}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4 text-ochre-400"><OmMark className="w-10 h-10" />
            <span className="font-serif-head text-xl text-white">{lang === "mr" ? TRUST.short_mr : TRUST.short_en}</span>
          </div>
          <p className="text-sm text-sand-100/70 leading-relaxed">{lang === "mr" ? TRUST.name_mr : TRUST.name_en}</p>
        </div>

        <div>
          <h4 className="font-serif-head text-lg text-ochre-400 mb-4">{lang === "mr" ? "दुवे" : "Links"}</h4>
          <ul className="space-y-2 text-sm">
            {NAV.slice(1, 9).map((n) => (
              <li key={n.path}><Link to={n.path} className="text-sand-100/80 hover:text-saffron-400 transition-colors">{L(n)}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif-head text-lg text-ochre-400 mb-4">{lang === "mr" ? "संपर्क" : "Contact"}</h4>
          <ul className="space-y-3 text-sm text-sand-100/80">
            <li className="flex gap-2"><MapPin size={18} className="shrink-0 text-saffron-500 mt-0.5" /><span>{lang === "mr" ? TRUST.address_mr : TRUST.address_en}</span></li>
            <li className="flex gap-2"><Phone size={18} className="shrink-0 text-saffron-500" /><span>{TRUST.phone_office} / {TRUST.phone_after}</span></li>
            <li className="flex gap-2"><Mail size={18} className="shrink-0 text-saffron-500" /><a href={`mailto:${TRUST.email}`}>{TRUST.email}</a></li>
          </ul>
          <a href={TRUST.facebook} target="_blank" rel="noreferrer" data-testid="footer-fb" className="mt-4 inline-flex items-center gap-2 text-sand-100/80 hover:text-saffron-400"><Facebook size={18} /> {TRUST.fbPageName}</a>
        </div>

        <div>
          <h4 className="font-serif-head text-lg text-ochre-400 mb-4">{lang === "mr" ? "ट्रस्ट तपशील" : "Trust Details"}</h4>
          <ul className="space-y-2 text-sm text-sand-100/80">
            <li>PAN: <span className="text-sand-100">{TRUST.pan}</span></li>
            <li>{lang === "mr" ? "नोंदणी" : "Reg."} / TAKNIKI: <span className="text-sand-100">{TRUST.reg}</span></li>
            <li className="text-ochre-400 font-semibold">{lang === "mr" ? "देणगी आयकर कलम ८०जी अंतर्गत करसवलत" : "Donations tax-exempt under IT Sec. 80G"}</li>
          </ul>
          <Link to="/admin" data-testid="footer-admin-link" className="block mt-5 text-xs text-sand-100/40 hover:text-ochre-400">Admin / Trust Login</Link>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 text-center text-xs text-sand-100/50">
        © {new Date().getFullYear()} {lang === "mr" ? TRUST.name_mr : TRUST.name_en}. {lang === "mr" ? "सर्व हक्क राखीव." : "All rights reserved."}
      </div>
    </footer>
  );
}

